module.exports = __webpack_public_path__ + "img/froggy-princess-preview.17979986.png";